import IExtension from "../IExtension";
import {Naja} from "naja";
require('@selectize/selectize');
import '@selectize/selectize/dist/css/selectize.bootstrap5.css';

export default class SelectizeExtension implements IExtension {

    public naja: Naja;

    public initialize(naja: Naja): void {
        if ($.fn.selectize === undefined) {
            console.error('Plugin "selectize.js" is missing!');
        }

        this.naja = naja;
        naja.addEventListener('init', () => this.init($('body')));
        naja.snippetHandler.addEventListener('afterUpdate', (e) => this.init($(e.detail.snippet)));
    }

    private init($root): void {
        $root.find('.selectize:not(.selectized)').each((i, el) => {
            const $el = $(el);

            if (!el.selectize && !$el.is('div')) {

                const selectizeOptions = {
                    plugins: ['remove_button'],
                    onInitialize: function (){
                        // Fix autocomplete
                        this.$control_input.attr('autocomplete', 'off');

                        // Fix bootstrap select classes
                        ['form-select', 'rounded'].forEach(htmlClass => {
                            if ($el.hasClass(htmlClass)) {
                                $el.parent().find('.selectize-input').addClass(htmlClass);
                            }
                        });
                    },
                    onDropdownOpen: ($dropDown: JQuery<HTMLElement>) => {
                        // Fix bootstrap select classes
                        if ($dropDown.hasClass('form-select')) {
                            $dropDown.removeClass('form-select');
                        }
                    },
                };

                const settings = $el.data('options') || {};

                this.addCreate(settings, selectizeOptions);

                $el.selectize(selectizeOptions);
            }
        });
    }

    /**
     * Add create function to selectized element
     * @param settings
     * @param options
     * @private
     */
    private addCreate(
        settings: {createUrl?: string, createText?: string},
        options: Selectize.IOptions<any, any>
    ): void {
        const createUrl = settings.createUrl;
        if (!createUrl) {
            return;
        }

        const addedItems = [];

        const self = this;
        options.create = async function (query, callback) {
            if (!query.length || query.length < this.minSearchLength) {
                return callback();
            }

            // already added items - do not add twice
            if (addedItems.includes(query)) {
                return callback();
            }

            addedItems.push(query);

            const selectize: Selectize.IApi<any, any> = this;
            try {
                const res = await self.naja.makeRequest('GET', createUrl, {query: query});

                if (res.id) {
                    selectize.addOption({value: res.id, text: query});
                    selectize.setValue(res.id)
                    selectize.refreshOptions(true);
                    callback(res);
                }
            } catch (err) {
                console.error('AJAX error');
                callback();
            }

        };


        if (settings.createText) {
            options.render = options.render || {};
            options.render.option_create = (data, escape) => `<div class="create">${settings.createText} <strong>${escape(data.input)}</strong>&hellip;</div>`;
        }
    }
}
